import { useEffect, useState } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";
import exceptionStore from "../../Stores/ExceptionAnalysisStore";
import ExceptionAnlysisActions from "../../Actions/ExceptionAnalysisActions";
import ExceptionConstants from "../../Constants/ExceptionAnalysisConstants";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";

function ExceptionAnalysisDetails(props) {
  const { excId } = props;
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [selectedExcDet, setSelectedExcDet] = useState([]);

  useEffect(() => {
    if (excId !== "") {
      setGlobalSpinner(true);
      ExceptionAnlysisActions.getExceptionLogs(excId);
    }
  }, [excId]);

  useEffect(() => {
    function getSelectedExceptionSuccess() {
      var res = exceptionStore.getSelectedExceptionResult();
      if (res) {
        setSelectedExcDet(res);
      } else {
        setSelectedExcDet([]);
      }
      setGlobalSpinner(false);
    }

    function getSelectedExceptionFailure() {
      setGlobalSpinner(false);
    }

    exceptionStore.addChangeListener(
      ExceptionConstants.GET_SELECTED_EXCEPTION_LOG_SUCCESS,
      getSelectedExceptionSuccess,
    );

    exceptionStore.addChangeListener(
      ExceptionConstants.GET_SELECTED_EXCEPTION_LOG_FAILURE,
      getSelectedExceptionFailure,
    );
    return () => {
      exceptionStore.removeChangeListener(
        ExceptionConstants.GET_SELECTED_EXCEPTION_LOG_SUCCESS,
        getSelectedExceptionSuccess,
      );

      exceptionStore.removeChangeListener(
        ExceptionConstants.GET_SELECTED_EXCEPTION_LOG_FAILURE,
        getSelectedExceptionFailure,
      );
    };
  }, []);

  function handleClose() {
    setSelectedExcDet([]);
  }

  return (
    <>
      <div
        className="modal fade"
        id="exceptionAnalysisDetails"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exceptionAnalysisDetails"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div
          className="modal-dialog d-flex justify-content-center"
          role="document"
        >
          <div className="modal-content exceptDetModel">
            <div className="modal-header">
              <h5 className="modal-title" id="exceptionAnalysisDetails">
                {localization.exceptionLogDetails}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="exceptionAnalysisDetails"
                onClick={handleClose}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col pl-0 ">
                  <div className="table-responsive px-3 exceptDetHeig">
                    <table className="table align-middle mb-0 table-striped table-hover table-sticky">
                      <thead className="bg-light"></thead>
                      <tbody>
                        {selectedExcDet ? (
                          <>
                            <tr>
                              <td className="border-right font-weight-bold">
                                {localization.id}
                              </td>
                              <td>{selectedExcDet.id}</td>
                            </tr>
                            <tr>
                              <td className="border-right font-weight-bold">
                                {localization.userName}
                              </td>
                              <td>{selectedExcDet.userName}</td>
                            </tr>
                            <tr>
                              <td className="border-right font-weight-bold">
                                {localization.dateTime}
                              </td>
                              <td>{selectedExcDet.dateTime}</td>
                            </tr>
                            <tr>
                              <td className="border-right font-weight-bold">
                                {localization.message}
                              </td>
                              <td>{selectedExcDet.message}</td>
                            </tr>
                            <tr>
                              <td className="border-right font-weight-bold">
                                {localization.methodInfo}
                              </td>
                              <td>{selectedExcDet.methodInfo}</td>
                            </tr>
                            <tr>
                              <td className="border-right font-weight-bold">
                                {localization.methodParams}
                              </td>
                              <td>{selectedExcDet.methodParams}</td>
                            </tr>
                            <tr>
                              <td className="border-right font-weight-bold">
                                {localization.exceptionDump}
                              </td>
                              <td>{selectedExcDet.exceptionDump}</td>
                            </tr>
                            <tr>
                              <td className="border-right font-weight-bold">
                                {localization.stackTrace}
                              </td>
                              <td>{selectedExcDet.stackTrace}</td>
                            </tr>
                          </>
                        ) : (
                          <tr>
                            <td classNameName="text-center" colSpan={100}>
                              <p>{localization.noRecordFound}</p>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ExceptionAnalysisDetails;
